// Provider registry: config id → adapter instance. The data layer iterates the
// race config and looks adapters up here, so it never imports concrete modules.
import type { VoteProvider, MarketProvider, FinanceProvider } from '../types/providers.ts';
import { manualProvider } from './votes/manual.ts';
import { civicapiProvider } from './votes/civicapi.ts';
import { apProvider } from './votes/ap.ts';
import { polymarketProvider } from './markets/polymarket.ts';
import { kalshiProvider } from './markets/kalshi.ts';
import { fecProvider } from './finance/fec.ts';

export const voteProviders: Record<string, VoteProvider> = {
  civicapi: civicapiProvider,
  manual: manualProvider,
  ap: apProvider,
};

export const marketProviders: Record<string, MarketProvider> = {
  polymarket: polymarketProvider,
  kalshi: kalshiProvider,
};

export const financeProviders: Record<string, FinanceProvider> = {
  fec: fecProvider,
};
